var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVerify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33398 8.49992C1.33398 4.81802 4.31875 1.83325 8.00065 1.83325C11.6825 1.83325 14.6673 4.81802 14.6673 8.49992C14.6673 12.1818 11.6825 15.1666 8.00065 15.1666C4.31875 15.1666 1.33398 12.1818 1.33398 8.49992ZM10.7177 5.78804C11.0188 5.99994 11.0911 6.4158 10.8792 6.71691L7.71252 11.2169C7.59605 11.3824 7.41078 11.4861 7.20885 11.4987C7.00685 11.5113 6.81012 11.4315 6.67405 11.2817L5.00736 9.44838C4.75968 9.17592 4.77976 8.75432 5.0522 8.50665C5.32464 8.25899 5.74627 8.27905 5.99394 8.55145L7.10092 9.76919L9.78878 5.94959C10.0007 5.64848 10.4165 5.57616 10.7177 5.78804Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerify);
export default __webpack_public_path__ + "static/media/icon-verify.1b70e268e6d02c359141d5109f98a406.svg";
export { ForwardRef as ReactComponent };